import { defineAsyncComponent, defineCustomElement } from "vue";


const linkButton = defineAsyncComponent(() => import("@atoms/LinkButton/LinkButton.ce.vue"));
const listLink = defineAsyncComponent(() => import("@atoms/ListLink/ListLink.ce.vue"));
const button = defineAsyncComponent(() => import("@atoms/Button/CustomButton.ce.vue"));
const quote = defineAsyncComponent(() => import("@atoms/Quote/Quote.ce.vue"));
const richtextEditor = defineAsyncComponent(() => import("@atoms/RichTextEditor/RichTextEditor.ce.vue"));

const hero = defineAsyncComponent(() => import("@molecules/Hero/Hero.ce.vue"));
const contentBanner = defineAsyncComponent(() => import("@molecules/ContentBanner/ContentBanner.ce.vue"));
const campaign = defineAsyncComponent(() => import("@molecules/CampaignModule/CampaignModule.ce.vue"));
const vimeoPlayer = defineAsyncComponent(() => import("@molecules/VimeoPlayer/VimeoPlayer.ce.vue"));
const newsCard = defineAsyncComponent(() => import("@molecules/NewsCard/NewsCard.ce.vue"));
const subpageNavigation = defineAsyncComponent(() => import("@molecules/SubpageNavigation/SubpageNavigation.vue"));
const contactListSection = defineAsyncComponent(() => import("@molecules/ContactListModule/ContactListModule.ce.vue"));
const listItem = defineAsyncComponent(() => import("@molecules/ListItem/ListItem.ce.vue"));
const socials = defineAsyncComponent(() => import("@molecules/Socials/Socials.ce.vue"));
const expertModule = defineAsyncComponent(() => import("@molecules/ExpertModule/ExpertModule.ce.vue"));
const regionalExpertModule = defineAsyncComponent(() => import("@molecules/RegionalExpertModule/RegionalExpertModule.ce.vue"));
const dataModule = defineAsyncComponent(() => import("@molecules/DataComponent/DataComponent.ce.vue"));
const accordion = defineAsyncComponent(() => import("@molecules/Accordion/Accordion.ce.vue"));
const map = defineAsyncComponent(() => import("@molecules/Map/Map.ce.vue"));
const testimonialComponent = defineAsyncComponent(() => import("@molecules/TestimonialComponent/TestimonialComponent.ce.vue"));
const videoComponent = defineAsyncComponent(() => import("@molecules/VideoComponent/VideoComponent.ce.vue"));
const table = defineAsyncComponent(() => import("@molecules/Table/Table.ce.vue"));
const employees = defineAsyncComponent(() => import("@molecules/Employees/Employees.ce.vue"));

const newsCardGrid = defineAsyncComponent(() => import("@organisms/NewsCardGrid/NewsCardGrid.ce.vue"));
const newsCardSection = defineAsyncComponent(() => import("@organisms/NewsCardSection/NewsCardSection.ce.vue"));
const listSection = defineAsyncComponent(() => import("@organisms/List/List.ce.vue"));
const navigation = defineAsyncComponent(() => import("@organisms/Navigation/Navigation.ce.vue"));
const footer = defineAsyncComponent(() => import("@organisms/Footer/Footer.ce.vue"));
const pageHero = defineAsyncComponent(() => import("@organisms/PageHero/PageHero.ce.vue"));
const relatedProjects = defineAsyncComponent(() => import("@organisms/RelatedProjects/RelatedProjects.ce.vue"));
const relatedPages = defineAsyncComponent(() => import("@organisms/RelatedPagesModule/RelatedPagesModule.ce.vue"));
const timeline = defineAsyncComponent(() => import("@organisms/Timeline/Timeline.ce.vue"));
 
const linkButtonComponent = defineCustomElement(linkButton);
const buttonComponent = defineCustomElement(button);
const contentBannerComponent = defineCustomElement(contentBanner);
const vimeoPlayerComponent = defineCustomElement(vimeoPlayer);
const campaignComponent = defineCustomElement(campaign);
const heroComponent = defineCustomElement(hero);
const newsCardComponent = defineCustomElement(newsCard);
const newsCardGridComponent = defineCustomElement(newsCardGrid);
const newsCardSectionComponent = defineCustomElement(newsCardSection);
const subpageNavigationComponent = defineCustomElement(subpageNavigation);
const contactListComponent = defineCustomElement(contactListSection);
const listComponent = defineCustomElement(listSection);
const listItemComponent = defineCustomElement(listItem);
const listLinkComponent = defineCustomElement(listLink);
const navigationComponent = defineCustomElement(navigation);
const footerComponent = defineCustomElement(footer);
const pageHeroComponent = defineCustomElement(pageHero);
const richtextEditorComponent = defineCustomElement(richtextEditor);
const quoteComponent = defineCustomElement(quote);
const socialsComponent = defineCustomElement(socials);
const expertComponent = defineCustomElement(expertModule);
const regionalExpertComponent = defineCustomElement(regionalExpertModule);
const dataComponent = defineCustomElement(dataModule);
const accordionComponent = defineCustomElement(accordion);
const mapComponent = defineCustomElement(map);
const relatedProjectsComponent = defineCustomElement(relatedProjects);
const relatedPagesComponent = defineCustomElement(relatedPages);
const timelineComponent = defineCustomElement(timeline);
const testimonialComponentModule = defineCustomElement(testimonialComponent);
const videoComponentModule = defineCustomElement(videoComponent);
const tableComponent = defineCustomElement(table);
const employeesComponent = defineCustomElement(employees);


export {
  contentBannerComponent, 
  linkButtonComponent, 
  vimeoPlayerComponent, 
  heroComponent, 
  campaignComponent, 
  newsCardComponent, 
  newsCardGridComponent, 
  newsCardSectionComponent, 
  buttonComponent, 
  subpageNavigationComponent,
  contactListComponent,
  listComponent,
  listItemComponent,
  listLinkComponent,
  navigationComponent,
  footerComponent,
  pageHeroComponent,
  richtextEditorComponent,
  quoteComponent,
  socialsComponent,
  expertComponent,
  regionalExpertComponent,
  dataComponent,
  accordionComponent,
  mapComponent,
  relatedProjectsComponent,
  relatedPagesComponent,
  timelineComponent,
  testimonialComponentModule,
  videoComponentModule,
  tableComponent,
  employeesComponent
};

export function register() {
  customElements.define("content-banner", contentBannerComponent);
  customElements.define("link-button", linkButtonComponent);
  customElements.define("vimeo-player", vimeoPlayerComponent);
  customElements.define("campaign-module", campaignComponent);
  customElements.define("hero-module", heroComponent);
  customElements.define("news-card", newsCardComponent);
  customElements.define("news-card-grid", newsCardGridComponent);
  customElements.define("news-card-section", newsCardSectionComponent);
  customElements.define("custom-button", buttonComponent);
  customElements.define("subpage-navigation", subpageNavigationComponent);
  customElements.define("contact-list", contactListComponent);
  customElements.define("list-module", listComponent);
  customElements.define("list-link", listLinkComponent);
  customElements.define("navigation-component", navigationComponent);
  customElements.define("footer-component", footerComponent);
  customElements.define("page-hero", pageHeroComponent);
  customElements.define("richtext-editor", richtextEditorComponent);
  customElements.define("quote-component", quoteComponent);
  customElements.define("socials-component", socialsComponent);
  customElements.define("expert-component", expertComponent);
  customElements.define("regional-expert-component", regionalExpertComponent);
  customElements.define("data-component", dataComponent);
  customElements.define("accordion-component", accordionComponent);
  customElements.define("map-component", mapComponent);
  customElements.define("related-projects", relatedProjectsComponent);
  customElements.define("related-pages", relatedPagesComponent);
  customElements.define("timeline-component", timelineComponent);
  customElements.define("testimonial-component", testimonialComponentModule);
  customElements.define("video-component", videoComponentModule);
  customElements.define("table-component", tableComponent);
  customElements.define("employees-component", employeesComponent);
}
register();


import { createApp } from "vue";  
import Header1 from "@components/Typography/Header1.ce.vue";

import CustomButton from "@atoms/Button/CustomButton.ce.vue";
import NavigationButton from "@atoms/NavigationButton/NavigationButton.vue";
import ListLink from "@atoms/ListLink/ListLink.ce.vue";
import ContactModule from "@atoms/Contact/ContactModule.ce.vue";
import QuoteModule from "@atoms/Quote/Quote.ce.vue";
import RichtextEditor from "@atoms/RichtextEditor/RichTextEditor.ce.vue";
import PageHeader from "@atoms/PageHeader/PageHeader.vue";


import Hero from "@molecules/Hero/Hero.ce.vue";
import NewsCard from "@molecules/NewsCard/NewsCard.ce.vue";
import SubpageNavigation from "@molecules/SubpageNavigation/SubpageNavigation.vue";
import CampaignModule from "@molecules/CampaignModule/CampaignModule.ce.vue"
import ContactList from "@molecules/ContactListModule/ContactListModule.ce.vue";
import ListItem from "@molecules/ListItem/ListItem.ce.vue";
import ContentBanner from "@molecules/ContentBanner/ContentBanner.ce.vue"
import ExpertModule from "@molecules/ExpertModule/ExpertModule.ce.vue"
import RegionalExpertModule from "@molecules/RegionalExpertModule/RegionalExpertModule.ce.vue"
import SocialsModule from "@molecules/Socials/Socials.ce.vue"
import InsightCard from "@molecules/InsightCard/InsightCard.vue";
import DataComponent from "@molecules/DataComponent/DataComponent.ce.vue";
import AccordionComponent from "@molecules/Accordion/Accordion.ce.vue";


import InsightsGrid from "@organisms/InsightsGrid/InsightsGrid.vue";
import ProjectsGrid from "@organisms/ProjectsGrid/ProjectsGrid.vue";
import NewsCardSection from "@organisms/NewsCardSection/NewsCardSection.ce.vue"
import NewsCardGrid from "@organisms/NewsCardGrid/NewsCardGrid.ce.vue";
import ListModule from "@organisms/List/List.ce.vue";
import PageHero from "@organisms/PageHero/PageHero.ce.vue"
import ProjectHero from "@organisms/ProjectHero/ProjectHero.ce.vue"

import PageWrapper from "@components/PageWrapper.vue";
import NewsPage from "./pages/NewsPage.vue";
import FrontPage from "./pages/FrontPage.vue";
import CampaignPage from "./pages/CampaignPage.vue";
import NewsArticlePage from "./pages/NewsArticlePage.vue";
import InsightsPage from "./pages/InsightsPage.vue";
import InsightArticlePage from "./pages/InsightArticlePage.vue";
import ProjectsPage from "./pages/ProjectsPage.vue";
import ProjectArticlePage from "./pages/ProjectArticlePage.vue";
import ContentPage from "./pages/ContentPage.vue";
import LandingPage from "./pages/LandingPage.vue";
import OfficePage from "./pages/OfficePage.vue";
import ErrorPage from "./pages/ErrorPage.vue";
import SearchPage from './pages/SearchPage.vue';
import VacancyPage from './pages/VacancyPage.vue';
import NewsletterPage from './pages/NewsletterPage.vue';
import CookieinformationPage from "./pages/CookieinformationPage.vue";

const newsletterApp = createApp(NewsletterPage);

const contentApp = createApp(ContentPage);
  contentApp.component("header-1", Header1);
  contentApp.component("page-hero", PageHero);
  contentApp.component("page-wrapper", PageWrapper);
  contentApp.component("socials-module", SocialsModule);

const errorApp = createApp(ErrorPage)
  errorApp.component("page-wrapper", PageWrapper);

const newsApp = createApp(NewsPage);
newsApp.component("header-1", Header1);
newsApp.component("custom-button", CustomButton);
newsApp.component("navigation-button", NavigationButton);
newsApp.component("news-card", NewsCard);
newsApp.component("news-card-grid", NewsCardGrid);
newsApp.component("subpage-navigation", SubpageNavigation);
newsApp.component("campaign-module", CampaignModule);
newsApp.component("content-banner", ContentBanner);
newsApp.component("news-card-section", NewsCardSection);
newsApp.component("contact-list", ContactList);
newsApp.component("contact-module", ContactModule);
newsApp.component("list-module", ListModule);
newsApp.component("list-item", ListItem);
newsApp.component("list-link", ListLink);
newsApp.component("page-wrapper", PageWrapper);
newsApp.component("page-header", PageHeader);
newsApp.component("data-component", DataComponent);
newsApp.component("expert-component", ExpertModule);
newsApp.component("regional-expert-component", RegionalExpertModule);

const pageApp = createApp(FrontPage);
pageApp.component("hero", Hero);
pageApp.component("header-1", Header1);
pageApp.component("page-wrapper", PageWrapper);
pageApp.component("data-component", DataComponent);
pageApp.component("expert-component", ExpertModule);
pageApp.component("regional-expert-component", RegionalExpertModule);
pageApp.config.compilerOptions.comments = true;

const campaignApp = createApp(CampaignPage);
pageApp.component("hero", Hero);
campaignApp.component("header-1", Header1);
campaignApp.component("page-wrapper", PageWrapper);
campaignApp.component("data-component", DataComponent);
campaignApp.component("expert-component", ExpertModule);
campaignApp.component("regional-expert-component", RegionalExpertModule);
campaignApp.config.compilerOptions.comments = true;


const articleApp = createApp(NewsArticlePage);
articleApp.component("header-1", Header1);
articleApp.component("custom-button", CustomButton);
articleApp.component("navigation-button", NavigationButton);
articleApp.component("news-card", NewsCard);
articleApp.component("news-card-grid", NewsCardGrid);
articleApp.component("subpage-navigation", SubpageNavigation);
articleApp.component("campaign-module", CampaignModule);
articleApp.component("content-banner", ContentBanner);
articleApp.component("news-card-section", NewsCardSection);
articleApp.component("contact-list", ContactList);
articleApp.component("contact-module", ContactModule);
articleApp.component("list-module", ListModule);
articleApp.component("list-item", ListItem);
articleApp.component("quote-component", QuoteModule);
articleApp.component("richtext-editor", RichtextEditor);
articleApp.component("page-hero", PageHero);
articleApp.component("expert-component", ExpertModule);
articleApp.component("regional-expert-component", RegionalExpertModule);
articleApp.component("page-wrapper", PageWrapper);
articleApp.component("socials-module", SocialsModule);
articleApp.component("data-component", DataComponent);
articleApp.component("accordion-component", AccordionComponent);


const insightsApp = createApp(InsightsPage);
  insightsApp.component("page-header", PageHeader);
  insightsApp.component("insights-grid", InsightsGrid);
  insightsApp.component("insight-card", InsightCard);
  insightsApp.component("data-component", DataComponent);
  insightsApp.component("expert-component", ExpertModule);
  insightsApp.component("regional-expert-component", RegionalExpertModule);

const insightsArticleApp = createApp(InsightArticlePage);

const projectsApp = createApp(ProjectsPage);
projectsApp.component("projects-grid", ProjectsGrid);

const projectArticleApp = createApp(ProjectArticlePage);

const aboutApp = createApp(LandingPage);
const officeApp = createApp(OfficePage);
const searchApp = createApp(SearchPage);
const vacancyApp = createApp(VacancyPage);
const cookieinformationApp = createApp(CookieinformationPage);


newsApp.mount("#news-app");
pageApp.mount("#page-app");
campaignApp.mount("#campaign-app");
articleApp.mount("#newsarticle-app");
insightsApp.mount("#insights-app");
insightsArticleApp.mount("#insights-article-app");
projectsApp.mount("#projects-app");
projectArticleApp.mount("#project-article-app");
contentApp.mount("#content-app");
aboutApp.mount("#about-app");
officeApp.mount("#office-app");
errorApp.mount("#error-app");
searchApp.mount("#search-app");
vacancyApp.mount("#vacancy-app");
newsletterApp.mount("#newsletter-app");
cookieinformationApp.mount("#cookieinformation-app");


